import Modal from 'react-modal'
import { FC, useEffect, useState } from 'react'
import Simulation from '../../Simulation'
import SimulationClose from '../simulation-close/SimulationClose'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from 'store/types'
import { hideSimulation } from 'store/simulation/actions/hideSimulation'
import { useRouter } from 'next/router'
import styles from './SimulationPopup.module.scss'
import classNames from 'classnames'
import { getSimulationRedirectRoute } from 'utils/routes'
import { Language } from 'types/language'

const SimulationPopup: FC = () => {
  // REDUX STORE
  const { opportunityId } = useSelector((state: Store) => state.app)
  const { didSimulation, visible } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // STATE
  const [showSimulationClose, setShowSimulationClose] = useState(false)

  // NEXT ROUTER
  const router = useRouter()
  const { pathname } = router
  const isRegistrationPage = pathname === '/producers/[slug]/order'
  const isProducerInfoPage = pathname === '/producers/[slug]'

  /**
   * Ends the simulation if it is completed & an opportunity ID is returned
   * Triggered on didSimulation & opportunity state change
   */
  useEffect(() => {
    if (visible && didSimulation && opportunityId && opportunityId !== '') endSimulation()
  }, [didSimulation, opportunityId])

  /**
   * Continues the simulation
   * (user clicked on continue in the close simulation popup)
   */
  const continueSimulation = () => setShowSimulationClose(false)

  /**
   * Handles the simulation ending
   */
  const endSimulation = () => {
    setShowSimulationClose(false)
    dispatch(hideSimulation())

    // Go to producer page if simulation completed & we're not at producer info page
    if (didSimulation && !isProducerInfoPage && !isRegistrationPage) {
      router.push(getSimulationRedirectRoute(router.locale as Language))
    }
  }

  return (
    <Modal
      isOpen={visible}
      onRequestClose={() => setShowSimulationClose(true)}
      style={{
        overlay: {
          zIndex: 100,
          background: 'rgba(0, 0, 0, 0.85)'
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          height: '90%',
          width: '90%',
          maxHeight: '600px',
          maxWidth: '800px',
          boxSizing: 'border-box',
          border: 'none',
          boxShadow: '0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08)'
        }
      }}
    >
      <div
        className={classNames('modal', styles['simulation-popup'])}
        style={{
          height: '100%',
          width: '100%',
          padding: '40px 16px',
          background: '#F7F7FA',
          boxSizing: 'border-box',
          overflow: 'auto'
        }}
      >
        <Simulation endSimulation={() => setShowSimulationClose(true)} />
      </div>

      <SimulationClose
        isOpen={showSimulationClose}
        simulationCompleted={didSimulation}
        onRequestClose={endSimulation}
        onRequestContinue={continueSimulation}
      />
    </Modal>
  )
}

export default SimulationPopup
